import * as React from "react";
import { Link } from "react-router-dom";
import * as FontAwesome from "react-fontawesome";
import * as moment from "moment";

export const fromMoment = (momentVal: moment.Moment): string => {
  return momentVal.format("YYYY-MM-DD'T'HH:mm:ss'Z'");
};

export const toMoment = (date: string): moment.Moment => {
  return moment(date, "YYYY-MM-DD'T'HH:mm:ss'Z'");
};

export const formatDate = (date: string): string =>
  toMoment(date).format("YYYY-MM-DD HH:mm:ss");

export const dateIsInFuture = (date: string): boolean =>
  toMoment(date) > moment();

export const formatCurrency = (amount: string | number): string => {
  return (
    (typeof amount === "number" ? amount : parseInt(amount, 10)) / 100
  ).toFixed(2);
};

export const formatCurrencyWithRands = (amount: string | number): string => {
  return amount ? "R" + formatCurrency(amount) : "N/A";
};

export const formatStatusColour = (status: string): string => {
  switch (status) {
    case "authed":
    case "valid":
    case "success":
    case "completed":
    case "accepted":
      return "#ebffeb";
    case "error":
    case "errored":
    case "invalid":
      return "#ffebeb";
    case "pending":
    default:
      return "#fff";
  }
};

export const formatColour = (color: string): string => {
  switch (color) {
    case "green":
      return "#ebffeb";
    case "red":
      return "#ffebeb";
    case "silver_mist":
      return "#f2f2f2";
    default:
      return "#fff";
  }
};

export const formatSecure3d = (status: string): JSX.Element => {
  if (status) {
    return <FontAwesome name="lock" style={{ color: "green" }} />;
  } else {
    return <FontAwesome name="unlock-alt" style={{ color: "red" }} />;
  }
};

// tslint:disable:align
// https://gist.github.com/penguinboy/762197
export const flattenObj = (object, prefix = "") => {
  return Object.keys(object).reduce((prev, element): any => {
    return object[element] && typeof object[element] === "object"
      ? { ...prev, ...flattenObj(object[element], `${prefix}${element}.`) }
      : { ...prev, ...{ [`${prefix}${element}`]: object[element] } };
  }, {});
};
// tslint:enable:align

type snapminLabelProps = {
  children: string;
  link: string;
  snapminLink: string;
};

export const SnapminLabel = ({
  children,
  link,
  snapminLink,
}: snapminLabelProps): JSX.Element => {
  return (
    <span>
      <Link className="blueLink" to={link}>
        {children}
      </Link>
      <a
        style={{ marginLeft: "6px" }}
        target="_blank"
        rel="noopener noreferrer"
        className="blueLink"
        href={snapminLink}
      >
        <FontAwesome name="info-circle" />
      </a>
    </span>
  );
};

const filters = {
  formatDate,
  formatCurrency,
  formatCurrencyWithRands,
  formatStatusColour,
  formatSecure3d,
  SnapminLabel,
};

export default filters;
